<template>
  <div class="flex-col group_10 ml-35">
    <div class="flex-col mt-9">
      <div class="mt-36 flex-col justify-start relative group_12">
        <div class="section_11"></div>
        <div class="flex-col section_10 pos">
          <div class="flex-row items-center group_13">
            <p class="row">
              <span class="key">您的姓名</span>
              <el-input class="value" placeholder="请输入您的姓名" v-model="form.name"></el-input>
            </p>
            <p class="row">
              <span class="key">您所在的企业名称</span>
              <el-input class="value" placeholder="请输入您所在的企业名称" v-model="form.qymc"></el-input>
            </p>
            <p class="row">
              <span class="key">您的手机号</span>
              <el-input class="value" placeholder="请输入您的手机号" v-model="form.sjh"></el-input>
            </p>
            <p class="row">
              <span class="key">反馈意见对应的企业名称</span>
              <el-input class="value" placeholder="请输入反馈意见对应的企业名称" v-model="form.fkyjqymc"></el-input>
            </p>
            <p class="row">
              <span class="key">反馈意见对应的创新项目名称</span>
              <el-input class="value" placeholder="请输入反馈意见对应的创新项目名称" v-model="form.fkyjxmmc"></el-input>
            </p>
            <p class="row">
              <span class="key">反馈意见具体描述</span>
              <el-input
                type="textarea"
                :rows="5"
                class="value"
                placeholder="请输入内容" v-model="form.fkyjjtms"></el-input>
            </p>
          </div>
        </div>
        <div class="flex-row justify-end self-stretch group_20">
          <div class="flex-col justify-start items-center text-wrapper_4 ml-31" @click="submit"><span class="font_9">完成</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      form: {
        name: '', // 您的姓名
        qymc: '', // 您所在的企业名称
        sjh: '', // 您的手机号
        fkyjqymc: '', // 反馈意见对应的企业名称
        fkyjxmmc: '', // 反馈意见对应的项目名称
        fkyjjtms: ''// 反馈意见对应的具体描述
      }
    }
  },
  methods: {
    async submit () {
      console.log('retro==>', this.form)
      const res = await this.$https.xmssjdAdd(this.form)
      if (res.data.status) {
        this.$message.success('提交成功')
        this.form = {
          name: '', // 您的姓名
          qymc: '', // 您所在的企业名称
          sjh: '', // 您的手机号
          fkyjqymc: '', // 反馈意见对应的企业名称
          fkyjxmmc: '', // 反馈意见对应的项目名称
          fkyjjtms: ''// 反馈意见对应的具体描述
        }
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .group_10 {
    margin-top: 37px;
    width: 1076px;
    .group_11 {
      padding: 0 142px;
      .image_2 {
        width: 64px;
        height: 65px;
      }
      .image_4 {
        width: 253px;
        height: 2px;
      }
      .image_3 {
        width: 65px;
        height: 65px;
      }
    }
    .text_16 {
      margin-left: 143px;
      line-height: 16px;
      margin-top: 9px;
    }
    .text_17 {
      line-height: 16px;
      margin-left: 8px;
      margin-top: 9px;
    }
    .text_18 {
      margin-right: 143px;
      position: relative;
      left: 9px;
      margin-top: 9px;
    }
    .group_12 {
      padding: 5px 0 22px;
      margin-top: 31px;
      .section_10 {
        .group_13 {
          display: flex;
          flex-direction: column;
          padding: 38px 25px 142px 31px;
          background-color: #fafafa;

          &.block2{
            margin-top: 144px;
            padding-top: 20px;
          }

          .row{
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top: 0px;

            .key{
              width: 228px;
              text-align: right;
            }

            .value{
              width: 537px;
              height: 35px;
              margin-left: 10px;

              /deep/ input{
                height: 35px;
                line-height: 35px;
                border: 2px solid #CAE3FD;
              }

              /deep/ textarea{
                width: 770px;
                border: 2px solid #CAE3FD;
                resize: none;
              }
            }
          }
        }
        .group_14 {
          margin-top: 19px;
          padding: 0 49px;
        }
        .text-wrapper_2 {
          padding: 10px 0;
          border-radius: 2px;
          background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          width: 538px;
          height: 36px;
          .text_20 {
            margin-left: 19px;
          }
        }
        .group_15 {
          margin-top: 18px;
          padding: 0 33px;
        }
        .group_16 {
          margin-top: 19px;
          padding: 0 64px;
        }
        .group_17 {
          padding: 0 81px;
          .image-wrapper {
            padding: 17px 0 14px;
            border-radius: 2px;
            background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=ef687600ce72699cda5051aff902c3ea.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            width: 538px;
            height: 36px;
            .image_5 {
              margin-right: 15px;
              width: 9px;
              height: 5px;
            }
          }
        }
        .view {
          margin-top: 18px;
        }
        .view_2 {
          margin-top: 19px;
        }
        .group_18 {
          margin-top: 25px;
          .text_21 {
            margin-top: 8px;
          }
          .image_6 {
            border-radius: 2px;
            width: 861px;
            height: 114px;
          }
        }
      }

    }
  }
  .font_7 {
    font-size: 15px;
    font-family: PingFang;
    line-height: 15px;
    color: #999999;
  }
  .section_12 {
    margin-right: 244px;
    padding: 39px 48px 44px;
    background-color: #fafafa;
    .group_19 {
      padding: 0 17px;
      .text_22 {
        line-height: 16px;
      }
    }
    .text-wrapper_3 {
      padding: 10px 0;
      border-radius: 2px;
      background-image: url('https://ide.code.fun/api/image?token=671290ea829f510014d9d592&name=c97a8fef57de3b6c3dd79ee9fbfdce0a.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 538px;
      height: 36px;
      .text_23 {
        margin-left: 19px;
        line-height: 16px;
      }
      .text_24 {
        margin-left: 19px;
      }
    }
  }
  .group_20 {
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 10;
    margin-top: 30px;
    .section_13 {
      padding: 8px 14px;
      background-color: #0071d6;
      border-radius: 2px;
      width: 94px;
      height: 32px;
      cursor: pointer;
      .image_7 {
        width: 17px;
        height: 16px;
      }
    }
    .text-wrapper_4 {
      padding: 8px 0;
      background-color: #0071d6;
      border-radius: 2px;
      width: 94px;
      height: 32px;
      margin-left: 32px;
      cursor: pointer;
    }
    .font_8 {
      font-size: 13px;
      font-family: Alibaba;
      letter-spacing: 2.5px;
      color: #ffffff;
      margin-left: 9px;
    }
    .font_9 {
      font-size: 13px;
      font-family: Alibaba;
      letter-spacing: 2.5px;
      color: #ffffff;
    }
  }
</style>
